import component from './DatePicker';

export default component;
